// Only follow a `next` redirect when it's a same-origin app path, never an
// external URL (open-redirect) or an auth route (which would loop).
export function safeNextPath(next: unknown): string | null {
  if (typeof next !== 'string' || !next.startsWith('/') || next.startsWith('//')) return null;
  if (/^\/(login|register|forgot-password|verify-email)\b/.test(next)) return null;
  return next;
}
